export function calculateProgress(stencils, selectedWeek, selectedStep) {
    let total = 0;
    let completed = 0;

    const stencilsInSelectedWeek = selectedWeek === 'all-weeks'
        ? stencils
        : stencils.filter(s => s.weekNum === Number(selectedWeek.replace('week', '')));
        
    total = stencilsInSelectedWeek.length;

    if (selectedStep === 'all'){
        completed = stencilsInSelectedWeek.filter(s => Number(s.carved) === 3).length;
    }
    else {
        completed = stencilsInSelectedWeek.filter(s => Number(s[selectedStep]) === 3).length;
        }

    return { completed, total };
}
